import { Roles } from '@/router/roles';

export const officialRoutes = [
	{
		path: 'officials',
		name: 'Officials Dashboard',
		meta: Roles.OFFICIAL,
		component: () => import('@/views/Officials/Dashboard/OfficialDashboard.vue')
	},
	{
		path: 'official',
		redirect: { name: 'Officials Dashboard' }
	},
	{
		path: 'my-reports',
		name: 'My Reports',
		meta: Roles.OFFICIAL,
		component: () => import('@/views/MatchReports/ReportsPage.vue'),
		props: {
			mode: 'official'
		}
	},
	{
		path: 'financial',
		name: 'Officials Financial Records',
		meta: Roles.OFFICIAL,
		component: () => import('@/finance/views/MyPay.vue'),
		props: { role: 'official' }
	},
	{
		path: 'contacts',
		name: 'contacts',
		meta: Roles.OFFICIAL,
		component: () => import('@/views/Officials/Contacts/Contacts.vue')
	}
];
